// extracted by css-extract-rspack-plugin
export default {"cls1":"Comments-cls1_k5l","cls2":"Comments-cls2_4VA Comments-cls1_k5l"};